import { Platform } from 'react-native';

// TODO: There's an iOS bug where text with lineHeight: 100% is not centered vertically
export const IOS_TEXT_ALIGN_OFFSET = Platform.OS === 'ios' ? 1 : 0;
